module.exports = __webpack_public_path__ + "img/logo.e4df9b9c.png";